




























































import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class NewTemplateSummary extends Vue {
  store = this.$store.direct;

  get name() {
    return this.store.state.template.selected.name;
  }

  get description() {
    return this.store.state.template.selected.description;
  }

  get file() {
    return this.store.state.template.selected.source
      ? this.store.state.template.selected.source.name
      : "";
  }

  get size() {
    return this.store.state.template.selected.source
      ? this.store.state.template.selected.source.size
      : 0;
  }

  get sections() {
    return this.store.state.template.selected.sections.length;
  }

  get inputs() {
    if (this.store.state.template.selected.sections.length == 0) return 0;
    const reducer = (accumulator: number, currentValue: number) =>
      accumulator + currentValue;
    return this.store.state.template.selected.sections
      .map(section => {
        return section.inputs.length;
      })
      .reduce(reducer);
  }
}
